import React from 'react';

export default () => <div>Welcome to Gear!</div>;
